import * as React from 'react'
import type { SVGProps } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgSaveSmartListIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 18 18"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="var(--app-active-accent)"
      d="M12.5 11.5v1.692q0 .213.144.357a.48.48 0 0 0 .357.143.49.49 0 0 0 .499-.5V11.5h1.692a.49.49 0 0 0 .357-.144.48.48 0 0 0 .143-.357.49.49 0 0 0-.5-.499H13.5V8.808a.49.49 0 0 0-.501-.5.488.488 0 0 0-.499.5V10.5h-1.692a.49.49 0 0 0-.5.501q0 .213.144.356a.49.49 0 0 0 .356.143zm-7.5 0h1q.213 0 .356-.144a.5.5 0 0 0 .144-.357.488.488 0 0 0-.5-.499H5a.49.49 0 0 0-.5.501q0 .213.144.356A.49.49 0 0 0 5 11.5m0-3h5q.212 0 .356-.144a.5.5 0 0 0 .144-.357.487.487 0 0 0-.5-.499H5a.49.49 0 0 0-.5.501q0 .213.144.356A.49.49 0 0 0 5 8.5m0-3h5q.212 0 .356-.144a.5.5 0 0 0 .144-.357.487.487 0 0 0-.5-.499H5a.49.49 0 0 0-.5.501q0 .213.144.356A.49.49 0 0 0 5 5.5M9.003 18a8.8 8.8 0 0 1-3.51-.708 9.1 9.1 0 0 1-2.859-1.924 9.1 9.1 0 0 1-1.925-2.856A8.75 8.75 0 0 1 0 9.003q0-1.867.709-3.51A9.1 9.1 0 0 1 2.63 2.634 9.1 9.1 0 0 1 5.487.709 8.8 8.8 0 0 1 8.997 0q1.866 0 3.51.709a9.1 9.1 0 0 1 2.859 1.922 9.1 9.1 0 0 1 1.925 2.857A8.8 8.8 0 0 1 18 8.997a8.8 8.8 0 0 1-.708 3.51 9.1 9.1 0 0 1-1.924 2.859 9.1 9.1 0 0 1-2.856 1.925A8.7 8.7 0 0 1 9.003 18M9 17q3.35 0 5.675-2.325T17 9t-2.325-5.675T9 1 3.325 3.325 1 9t2.325 5.675T9 17"
    />
  </svg>
)
export default SvgSaveSmartListIcon
